import { Flex, InputGroup } from "@chakra-ui/react";

import styled from "@emotion/styled";

// Sentence Box Css
export const TypeInBox = styled(InputGroup)`
  background: #fff;
  border-color: #000;
  font-family: ${(props) => props.theme.fonts.text};
  line-height: 24px;
`;

// Block CSS
export const BlockCard = styled(Flex)`
  transition: all 0.5s ease-in;
  width: 100%;
  font-family: ${(props) =>
    props.fontFamily ? props.fontFamily : props.theme.fonts.text};
  color: ${(props) => props.theme.colors.secondary};

  hr {
    background: #131215;
    height: 1px;
  }

  .left {
    font-weight: bold;
  }

  .right {
    border-left: 1px solid #000;
  }
`;

// SettingsBLOCK Css
export const Settings = styled(Flex)`
  width: 100%;
  font-family: ${(props) =>
    props.fontFamily ? props.fontFamily : props.theme.fonts.roboto};

  input,
  select {
    color: #787878;
    border-color: #7d7d7d;
  }

  .title {
    line-height: 24px;
  }
`;

// For Head05
